import { useField } from 'formik'
import { useCallback, WheelEvent } from 'react'
import { InputNumber as AntdInputNumber } from '../../InputNumber'
import type { InputNumberProps as AntdInputNumberProps } from '../../InputNumber'
import type { FormikFieldProps } from '../typings/FieldProps'

export type InputNumberProps = FormikFieldProps & AntdInputNumberProps

export const InputNumber = ({
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  value: _valueProp,
  ...restProps
}: InputNumberProps) => {
  const [field, , helpers] = useField(name)
  const { value, onBlur } = field
  const { setValue } = helpers

  const handleChange = useCallback(
    (value: any) => {
      setValue(value)
      onChangeProp?.(value)
    },
    [setValue, onChangeProp]
  )

  const handleBlur = useCallback(
    (event: any) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )

  const handleWheel = useCallback(
    (event: WheelEvent<HTMLInputElement>) => {
      // Disable the default scrolling behavior for input with type='number' (allowing the mouse wheel to change the value)
      if (restProps?.type === 'number' && !restProps?.changeOnWheel) {
        event.currentTarget.blur()
      }
    },
    [restProps?.changeOnWheel, restProps?.type]
  )

  return (
    <AntdInputNumber
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="#"
      onWheel={handleWheel}
      {...restProps}
    />
  )
}
